import axios from "axios";

export const fetchCompetitionsList = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_COMPETITIONS_LIST_REQUEST" });
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getCompetitionsList`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "FETCH_COMPETITIONS_LIST_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_COMPETITIONS_LIST_FAILURE",
      payload: error.message,
    });
  }
};
